// import './App.css';
import { useEffect, useState } from "react";
import {
  FormControl,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import { default as ReactSelect } from "react-select";

import { getAssessmentSection, getQuestion } from "../services/api";

const classes = {};

function TargetSelector({ assessmentSections, selectedAssessmentSection, value, setValue }) {
  const [loading, setLoading] = useState(false);
  const [assessmentSection, setAssessmentSection] = useState(selectedAssessmentSection);
  const [assessmentSectionId, setAssessmentSectionId] = useState(selectedAssessmentSection.id);
  const [questionLabel, setQuestionLabel] = useState("");

  const handleChangeAS = (event) => {
    setLoading(true);
    if (assessmentSectionId !== event.value) {
      setAssessmentSectionId(event.value);
      getAssessmentSection(event.value)
        .then((res) => {
          setValue("");
          setAssessmentSection(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleChange = (event) => {
    setValue(event.value);
  };

  useEffect(() => {
    if (assessmentSection != selectedAssessmentSection) {
      setAssessmentSection(selectedAssessmentSection);
      setAssessmentSectionId(selectedAssessmentSection.id);
    }
  }, [selectedAssessmentSection]);

  useEffect(() => {
    if (value) {
      let q = assessmentSection.questions.find((q) => {
        return q.id == value;
      });
      if (!q) {
        setLoading(true);
        getQuestion(value).then((res) => {
          getAssessmentSection(res.assessmentSections[0].id).then((resp) => {
            setLoading(false);
            setAssessmentSection(resp);
            setAssessmentSectionId(resp.id);
          });
        });
      } else {
        setQuestionLabel(q.questionTRs[0].text);
      }
      console.log("si existe valor");
    }
  }, [assessmentSection, value]);

  console.log(value);

  const assessmentSectionOptions = [];
  assessmentSections.forEach((as) => {
    let tr;
    if(as.assessmentSectionTRs.length) {
      tr = as.assessmentSectionTRs.find((x) => {
        return x.language == "EN";
      });
      if (!tr) tr = as.assessmentSectionTRs[0];
    }
    assessmentSectionOptions.push({
      value: as.id,
      label: `${as.id} - ${tr ? (tr.nickname || tr.section_title) : ""}`,
    });
  })

  const questionOptions = [];
  assessmentSection.questions.forEach((q) => {
    let tr;
    if(q.questionTRs.length) {
      tr = q.questionTRs.find((x) => {
        return x.language == "EN";
      });
      if (!tr) tr = q.questionTRs[0];
    }
    questionOptions.push({
      value: q.id,
      label: `${q.id} -  ${tr ? tr.text : ""}`,
    })
  })
  return (
    <LoadingOverlay active={loading} spinner>
      {/* <span id="demo-simple-select-label">Target</span> */}
      <FormControl className="inputForms">
        <p className="labelNew">Assessment Section Target</p>
        {/* <Select
          labelId="targetLabelAssessmentSection"
          id="targetAssessmentSection"
          value={assessmentSectionId}
          label="Assessment Section"
          onChange={handleChangeAS}
        >
          {assessmentSections.map((as) => {
            let tr = as.assessmentSectionTRs.find((x) => {
              return x.language == "EN";
            });
            if (!tr) tr = as.assessmentSectionTRs[0];
            return <MenuItem value={as.id}>
              {as.id} - {tr.section_title}
            </MenuItem>
          ))}
        </Select> */}
        <ReactSelect
          value={{
            value: assessmentSectionId,
            label: `${assessmentSectionId} -  ${assessmentSection.assessmentSectionTRs[0].section_title}`,
          }}
          options={assessmentSectionOptions}
          labelId="targetLabelAssessmentSection"
          id="targetAssessmentSection"
          onChange={handleChangeAS}
        />
      </FormControl>
      <FormControl className="inputForms">
        <p className="labelNew">Question</p>
        {/* <Select
          labelId="targetLabelQuestion"
          id="targetQuestion"
          value={value}
          label="Question"
          onChange={handleChange}
        >
          <MenuItem value={""}>None</MenuItem>
          {assessmentSection.questions.map((q) => {
            let tr = q.questionTRs.find((x) => {
              return x.language == "EN";
            });
            if (!tr) tr = q.questionTRs[0];
            return <MenuItem value={q.id}>
              {q.id} - {tr.text}
            </MenuItem>
          ))}
        </Select> */}

        <ReactSelect
          value={{
            value: value,
            label: value ? `${value} - ${questionLabel}` : "",
          }}
          // defaultValue={{
          //   value: value,
          //   label: `${value} - question label here`,
          // }}
          options={questionOptions}
          labelId="targetLabelQuestion"
          id="targetQuestion"
          label="Question"
          onChange={handleChange}
        />
      </FormControl>
    </LoadingOverlay>
  );
}

export default TargetSelector;
